(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shuffling-collection-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__fcShuffleInit) return;
    window.__fcShuffleInit = true;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    function start() {
      document.querySelectorAll('.fc-shuffle-slot').forEach(function (slot) {
        if (slot.dataset.fcReady === '1') return;
        var cards = slot.querySelectorAll('.fc-shuffle-card');
        if (cards.length < 2) return;
        slot.dataset.fcReady = '1';

        var intervalMs = parseInt(slot.dataset.rotationMs, 10) || 3000;
        var stagger = parseInt(slot.style.getPropertyValue('--fc-stagger'), 10) || 0;
        var current = 0;

        setTimeout(function () {
          setInterval(function () {
            var next = (current + 1) % cards.length;
            cards[current].classList.remove('fc-shuffle-card--active');
            cards[next].classList.add('fc-shuffle-card--active');
            current = next;
          }, intervalMs);
        }, stagger * 260 + Math.random() * 400);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
